// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/guild/components/modals/guild_tabs/guild_overview_tab/GuildOverviewTab.module.css';
import type {FormInputs} from '@app/features/guild/utils/guild_tabs/GuildOverviewTabUtils';
import {Button} from '@app/features/ui/button/Button';
import {CardAlignmentControls} from '@app/features/ui/card_alignment_controls/CardAlignmentControls';
import {GuildSplashCardAlignment} from '@app/vendor/constants/GuildConstants';
import {Trans, useLingui} from '@lingui/react/macro';
import {EyeIcon} from '@phosphor-icons/react';
import clsx from 'clsx';
import type React from 'react';
import type {UseFormReturn} from 'react-hook-form';
export const GuildInviteSplashSettingsField: React.FC<{
	form: UseFormReturn<FormInputs>;
	canManageGuild: boolean;
	onPreviewInvitePage?: () => void;
	onPreviewInviteModal?: () => void;
}> = ({form, canManageGuild, onPreviewInvitePage, onPreviewInviteModal}) => {
	const {t} = useLingui();
	const alignment = form.watch('splash_card_alignment', GuildSplashCardAlignment.CENTER);
	return (
		<div className={styles.splashSettingsContainer}>
			<div className={styles.splashSettingsRow}>
				<div className={styles.splashSettingsColumn}>
					<div className={styles.iconField}>
						<Trans>Preview</Trans>
					</div>
					<div className={styles.splashSettingsButtons}>
						{onPreviewInvitePage ? (
							<Button
								variant="secondary"
								small={true}
								onClick={onPreviewInvitePage}
								disabled={!canManageGuild}
								className={styles.invitePageButton}
							>
								<EyeIcon size={16} weight="bold" />
								<Trans>Invite Page</Trans>
							</Button>
						) : null}
						{onPreviewInviteModal ? (
							<Button variant="secondary" small={true} onClick={onPreviewInviteModal} disabled={!canManageGuild}>
								<EyeIcon size={16} weight="bold" />
								<Trans>Invite Modal</Trans>
							</Button>
						) : null}
					</div>
					<p className={styles.splashSettingsHelper}>
						<Trans>See how your invite looks to visitors.</Trans>
					</p>
				</div>
				<div className={clsx(styles.splashSettingsColumn, styles.splashSettingsColumnRight)}>
					<div className={styles.iconField}>
						<Trans>Card Alignment</Trans>
					</div>
					<div className={styles.alignmentControlsRow}>
						<CardAlignmentControls
							value={alignment}
							onChange={(value) => form.setValue('splash_card_alignment', value, {shouldDirty: true})}
							disabled={!canManageGuild}
							className={styles.cardAlignmentControls}
							disabledTooltipText={t`Alignment controls are only available on wider screens`}
						/>
					</div>
					<p className={styles.splashSettingsHelper}>
						<Trans>Only applies on wide screens.</Trans>
					</p>
				</div>
			</div>
		</div>
	);
};
